/* Dauber HQ attribution — persist inbound query params (UTMs, click IDs, etc.)
   in a .dauberhq.com cookie so they survive on-site navigation and the app can
   read them at registration. Rules + cookie contract live in attribution-state.js. */

import {
  COOKIE_NAME,
  MAX_AGE_DAYS,
  nextAttribution,
  encodeAttribution,
  decodeAttribution,
  readCookie,
  cookieDomain,
} from './attribution-state.js';

(function () {
  'use strict';

  try {
    var loc = window.location;
    var existing = decodeAttribution(readCookie(document.cookie, COOKIE_NAME));
    var data = nextAttribution({
      search: loc.search,
      pathname: loc.pathname,
      referrer: document.referrer,
      hostname: loc.hostname,
      existing: existing,
    });
    if (!data) return;

    var domain = cookieDomain(loc.hostname);
    document.cookie = COOKIE_NAME + '=' + encodeAttribution(data) +
      '; Path=/' +
      '; Max-Age=' + (MAX_AGE_DAYS * 86400) +
      '; SameSite=Lax' +
      (domain ? '; Domain=' + domain : '') +
      (loc.protocol === 'https:' ? '; Secure' : '');
  } catch (e) {
    // Attribution is best-effort; never break the page over it.
  }
})();
